import React from 'react';

const ProExclusiveLogo = () => {
  return (
    <div className="flex items-center gap-12">
      <div className="h-px w-full bg-grayscale-50 sm:h-3" />
      <p className="m-0 flex-shrink-0">
        <span className="font-serif text-[15px] font-medium text-pro-red">Pro</span>{' '}
        <span className="font-sans text-overline uppercase text-grayscale-80">Exclusive</span>
      </p>
      <div className="h-px w-full bg-grayscale-50 sm:h-3" />
    </div>
  );
};

export default ProExclusiveLogo;
